// extracted by mini-css-extract-plugin
export var container = "Pagination-module--container--M+f2H";
export var container__button = "Pagination-module--container__button--5nCFc";
export var container__items = "Pagination-module--container__items--T2ldI";